import {
  useNiftyFiftyTemplate,
  useNiftyFiftyUpdate,
} from 'Event/template/NiftyFifty'
import {generateHashId} from 'lib/crypto/hash'
import {useAddTranslation, useTranslationLanguage} from 'Event/LanguageProvider'
import {parseVariables} from 'lib/template'

export function useDuplicateAgenda() {
  const template = useNiftyFiftyTemplate()
  const save = useNiftyFiftyUpdate()
  const addTranslation = useAddTranslation()
  const targetLanguage = useTranslationLanguage()

  return (sourceId: string) => {
    const source = template.agendaList.items[sourceId]
    if (!source) {
      return
    }

    const position = Object.keys(template.agendaList.items).length + 1
    const translations =
      template.localization?.translations?.[targetLanguage] ?? {}

    const resolve = (value: string | null | undefined) => {
      const [variable] = parseVariables(value ?? '')
      return variable ? translations[variable] ?? '' : value ?? ''
    }

    return generateHashId([
      'niftyfifty_',
      'agenda_item_',
      Date.now().toString(),
      Math.random().toString(),
    ]).then((id) => {
      save({
        localization: addTranslation({
          [`agenda_item_${id}_text`]: resolve(source.text),
          [`agenda_item_${id}_description`]: resolve(source.description),
          [`agenda_item_${id}_link`]: resolve(source.link),
        }),
        agendaList: {
          items: {
            [id]: {
              ...source,
              position,
              text: `{{agenda_item_${id}_text}}`,
              description: `{{agenda_item_${id}_description}}`,
              link: `{{agenda_item_${id}_link}}`,
            },
          },
        },
      })
    })
  }
}
